import { createReducer, on } from '@ngrx/store';
import { ConfigurationProfileApiActions } from './configuration-profile.actions';
import { adapter, initialState } from './configuration-profile.state';

export const configurationProfileFeatureKey = 'configurationProfile';

export const configurationProfileReducer = createReducer(
  initialState,
  on(ConfigurationProfileApiActions.configurationProfilesLoaded, (state, { configurationProfiles }) =>
    adapter.upsertMany(configurationProfiles, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectConfigurationProfileIds = selectIds;

export const selectConfigurationProfileEntities = selectEntities;

export const selectAllConfigurationProfiles = selectAll;
